import { createSlice } from "@reduxjs/toolkit";
import { getSalesOrderList } from "../../reduxApi/admin/SalesOrderReduxApi";

const SalesOrderSlice = createSlice({
    name: 'salesOrder',
    initialState: {
        status: 'idel',
        isFiltered: false,
        salesOrder: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deletesalesOrderAction: (state, action) => {
    // Add safety check for state.salesOrder
    if (!state.salesOrder || !Array.isArray(state.salesOrder)) {
        return;
    }
    
    action.payload.forEach((id) => {
        const index = state.salesOrder.findIndex((item) => item.ROWID === id);
        if (index !== -1) {
            state.salesOrder.splice(index, 1);
        }
    });
},

       

updatesalesOrderAction: (state, action) => {
    console.log("action.payload", action.payload)
    
    // Safety check: ensure state.salesOrder exists
    if (!state.salesOrder) {
        state.salesOrder = []
        return // Exit early since there's nothing to update
    }
    
    const index = state.salesOrder.findIndex((item) => item.ROWID === action.payload.id)
    if (index !== -1) {
        state.salesOrder.splice(index, 1, action.payload)
    }
},
        // addsalesOrderAction: (state, action) => {
        //     console.log("action--->",action.payload);
            
        //     const temp = action.payload;
        //     console.log("temp",temp)
        //     temp.ROWID = action.payload.ROWID;
        //     console.log("temp.ROWID",temp.ROWID);
            
        //     state.salesOrder.unshift(temp); //add new data at beginning of array 
        // }

        addsalesOrderAction: (state, action) => {
  console.log("action--->", action.payload);
  
  const temp = action.payload;
  console.log("temp", temp);
  temp.ROWID = action.payload.ROWID;
  console.log("temp.ROWID", temp.ROWID);
  
  // Add safety check
  if (!state.salesOrder) {
    state.salesOrder = [];
  }
  
  state.salesOrder.unshift(temp); // Add new data at beginning of array 
}
    },
    extraReducers: (builder) => {
        builder.addCase(getSalesOrderList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getSalesOrderList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.salesOrder = action.payload.data.salesOrders;
            })
    }
})
export const { deletesalesOrderAction, updatesalesOrderAction, addsalesOrderAction, setFilteredStatus } = SalesOrderSlice.actions
export default SalesOrderSlice.reducer